// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","wrapper":"wrapper-1eGTM","monthsList":"monthsList-1UVdP","monthsList_withPrice":"monthsList_withPrice-3OlLc"};